export default __webpack_public_path__ + "static/media/apple.438de3d7.png";